import io from 'socket.io-client';
import { auth } from '../config/firebase';
import { isClientes, isProduction } from '../config/constants';
import { obtenerNombreEmpresaConReintentos } from './api';

const SOCKET_URL = isProduction ? 'https://dufy-asesorias-api.46fbym.easypanel.host' : 'http://localhost:8080'; // O tu URL de producción

// Usamos un objeto para gestionar las conexiones por namespace
let socket = null;

//Conectar socket
export const connectSocket = async () => {
  if (socket && socket.connected) {
    console.log('Socket ya está conectado.');
    return;
  }

  const user = auth.currentUser;
  if (!user) {
    console.warn('Socket: Intento de conexión sin usuario logueado.');
    return;
  }

  try{
    const token = await user.getIdToken();
    socket = io(SOCKET_URL, {
      auth: {
        token: token,
        nombreEmpresa: await obtenerNombreEmpresaConReintentos(),
        isCliente: isClientes,
      }
    });

    socket.on('connect', () => {
      console.log(`✅ Socket conectado exitosamente: ${socket.id}`);
    });

    socket.on('disconnect', (reason) => {
      console.log(`Socket desconectado: ${reason}`);
      // Limpiamos la instancia si la desconexión fue intencional o fallida
      if (reason === 'io server disconnect' || reason === 'io client disconnect') {
        socket = null;
      }
    });

    socket.on('connect_error', (err) => {
      // Esto se disparará si tu middleware 'io.use()' en el backend falla
      console.error(`Error de conexión del Socket: ${err.message}`);
      if (err.message === 'Authentication failed' || err.message === 'Token no proporcionado') {
        socket.disconnect(); // No intentes reconectar si la auth falló
        socket = null;
      }
    });

  }
  catch(error){
    console.error("Error al obtener token para el socket:", error);
  }
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
    console.log("Socket desconectado y limpiado.");
  }
};

export const getSocket = () => {
  if (!socket) {
    console.warn("Socket no inicializado. Llama a connectSocket() después del login.");
  }
  return socket;
};


